import _ from "lodash";
export default {
  data: function() {
    return {
      //服务内容列表数组
      serviceIconList: [
        {
          name: "专业师资",
          src: require("./img/top_teacher.png")
        },
        {
          name: "视频课程",
          src: require("./img/video_teacher.png")
        },
        {
          name: "随堂练习",
          src: require("./img/practice.png")
        },
        {
          name: "错题管理",
          src: require("./img/exam.png")
        },
        {
          name: "实时监控",
          src: require("./img/simulate_exam.jpg")
        },
        {
          name: "模拟考试",
          src: require("./img/high_frequency.png")
        }
      ],
      //服务优势列表数组
      serviceAdvantageList: [
        {
          name: "技能提升",
          text1: "实施职业技能提升计划，搭建高素质人才培养体系。",
          // text2: "平均水平30个百分点",
          src: require("./img/advantage_one.png")
        },
        {
          name: "专业师资",
          text1: "  携手诸多行业师资，搭建科学课程体系，研发专业课程内容。",
          // text2: "线上面对面权威授课",
          src: require("./img/advantage_two.png")
        },
        {
          name: "优质课程",
          text1: "大量精品课程，内容制作精良,为您提供贴心的一站式学习服务。",
          // text2: "搞定，冲刺模考串讲保驾护航",
          src: require("./img/advantage_three.png")
        },
        {
          name: "紧跟市场",
          text1:
            "大力培养健康产业专业人才，符合社会发展的需要，满足用人单位需求。",
          // text2: "实时更新课程内容",
          src: require("./img/advantage_four.png")
        }
      ],
      //你将得到数组列表
      willGetList: [
        {
          name: "稀缺的专业知识技能",
          srcGray: require("./img/will_get1_gray.png"),
          srcActive: require("./img/will_get1_active.png")
        },
        {
          name: "良好的职业发展机会",
          srcGray: require("./img/will_get2_gray.png"),
          srcActive: require("./img/will_get2_active.png")
        },
        {
          name: "社会的尊重",
          srcGray: require("./img/will_get3_gray.png"),
          srcActive: require("./img/will_get3_active.png")
        }
      ],
      //鼠标输入的选中的值
      serviceAdvantageCurrent: null,
      //将得到
      willGetCurrent: null,
      beginFlag: false,
      serviceIsScroll: false
    };
  },
  methods: {
    //服务优势的
    serviceAdvantageMouseenter(index) {
      this.serviceAdvantageCurrent = index;
    },
    //服务优势的
    serviceAdvantageMousemove() {
      this.serviceAdvantageCurrent = null;
    },
    //你将得到
    willGetMouseenter(index) {
      this.willGetCurrent = index;
    },
    //你将得到
    willGetMouseleave() {
      this.willGetCurrent = null;
    },
    //让我们开始
    beginMouseEnter() {
      this.beginFlag = true;
    },
    //让我们开始
    beginMouseleave() {
      this.beginFlag = false;
    },
    //点击这里去学习
    toStudy() {
      window.location.href = "./studyIndex.html";
    },
    //滚动和
    scrollHandle() {
      const offset = this.$refs.service.getBoundingClientRect(); // vue中，使用this.$el获取当前组件的根元素
      const offsetTop = offset.top;
      const offsetBottom = offset.bottom;
      // 进入可视区域
      if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
        if (this.serviceIsScroll) {
          return;
        }
        this.serviceIsScroll = true;
      } else {
        this.serviceIsScroll = false;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(
        "scroll",
        _.throttle(this.scrollHandle, 200),
        true
      );
    });
  }
};
